import { Tick, WarningLight } from '@audio-network/componentlibrary/icons'
import { toast as toastify, ToastOptions } from 'react-toastify'

import { StatusToast } from '@/components/shared/Toast'

type ToastMessage = string | React.ReactNode

type ToastProps = ToastOptions &
	React.HTMLProps<HTMLDivElement> & {
		startIcon?: React.ReactNode
		[key: string]: unknown
	}

export const DEFAULT_ERROR_OPTIONS: ToastOptions = {
	autoClose: 3000,
	type: 'error',
	closeOnClick: true,
}

export const DEFAULT_SUCCESS_OPTIONS: ToastOptions = {
	autoClose: 3000,
	type: 'success',
	closeOnClick: true,
}

const createToast = (
	message: ToastMessage,
	props?: ToastProps,
	options?: ToastOptions
): string | number => {
	return toastify(
		<StatusToast startIcon={props?.startIcon} {...props}>
			{message}
		</StatusToast>,
		options
	)
}

export const toast = Object.assign(
	// Default toast
	(message: ToastMessage, props?: ToastProps) => createToast(message, props),
	{
		success: (message: ToastMessage, props?: ToastProps) =>
			createToast(
				message,
				{ ...props, startIcon: <Tick /> },
				DEFAULT_SUCCESS_OPTIONS
			),

		error: (message: ToastMessage, props?: ToastProps) =>
			createToast(
				message,
				{ ...props, startIcon: <WarningLight /> },
				DEFAULT_ERROR_OPTIONS
			),

		info: (message: ToastMessage, props?: ToastProps) =>
			createToast(message, props, { ...DEFAULT_SUCCESS_OPTIONS, type: 'info' }),

		warning: (message: ToastMessage, props?: ToastProps) =>
			createToast(
				message,
				{ ...props, startIcon: <WarningLight /> },
				{ ...DEFAULT_SUCCESS_OPTIONS, type: 'warning' }
			),

		dismiss: toastify.dismiss,

		// Allow access to the underlying toast library if needed
		raw: toastify,
	}
)
